import React from 'react';
import { RenewalLineItem } from '../utils/renewalTableTileTypes';
import { formatUsageLimit } from '../../../shared/utils/formatUsageLimit';
import './RenewalLineItems.scss';
import { SubscriptionRenewalLineItemUpdate } from '../../../store/api';
import isEqual from 'lodash/isEqual';
import { RenewalCopyCounter } from './RenewalCopyCounter';
import { t } from 'i18next';
import FormatCurrency from '../../../shared/utils/formatCurrency';

interface Props {
    items: RenewalLineItem[];
    onAmountChange: (item: SubscriptionRenewalLineItemUpdate[]) => void;
}

export const RenewalLineItems = (props: Props) => {
    const handleAmountChange = (lineItem: RenewalLineItem) => {
        const nextLineItems: SubscriptionRenewalLineItemUpdate[] = props.items.map(({ amount, price }) => {
            if (isEqual(lineItem.price, price)) {
                amount = lineItem.amount;
            }

            return {
                amount,
                usageCondition: {
                    usageLimit: price.usageLimit,
                    lendingModel: price.lendingModel,
                    termLimit: price.termLimit
                }
            };
        });

        props.onAmountChange(nextLineItems);
    };

    return (
        <td className="renewal-line-items">
            {props.items.map(item => {
                return (
                    <div key={item.price.netValue} className="sub-item">
                        <RenewalCopyCounter
                            onChange={(type, value) => {
                                const nextItemAmount = { ...item };
                                switch (type) {
                                    case 'increase':
                                        nextItemAmount.amount = nextItemAmount.amount + value;
                                        break;
                                    case 'decrease':
                                        nextItemAmount.amount = nextItemAmount.amount - value;
                                        break;
                                }
                                handleAmountChange(nextItemAmount);
                            }}
                            value={item.amount}
                            className="renewal-copy-counter"
                        />
                        <div className="sub-item__price">
                            <b>{formatUsageLimit(t, item.price.usageLimit)}</b>
                            <p>
                                {t('numberFormat.numberWithCurrencySymbol', {
                                    val: FormatCurrency.convertIntegerToCurrencyFormat(item.price.netValue),
                                    currencySymbol: FormatCurrency.mapCurrencyToSymbol(item.price.currency)
                                })}
                            </p>
                        </div>
                    </div>
                );
            })}
        </td>
    );
};
